import React, { useEffect, useState } from "react"
import { useFormik } from "formik"
import _, { find, map, some, upperCase } from "lodash"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import StepCard from "./StepCard"
import CustomerInfo from "./components/CustomerInfo"
import AmountNumbers from "./components/AmountNumbers"
import OrderResume from "../../components/OrderResume"
import BreadcrumbRouter from "../../components/Breadcrumb"
import SelectionFixedVoice from "./components/SelectionFixedVoice"
import PortedNumbers from "./components/PortedNumber"
import { showToast } from "../../../../components/Toast"

import styles from "./styles.css"

import {
  ERRORS_FIXED_VOICE,
  FIELDS_TO_VALIDATE,
  INITIAL_STATE_FORM,
  INITIAL_VALUES,
  TYPE_OF_SALE,
  validate
} from "./constants"
import { FormUtils } from "./utils"
import {
  getPartnerCircuit,
  partnerSales
} from "services/state/fixedVoice/action"
import { removeMaskCPFCNPJ, removeMaskTel } from "services/utils/mask"
import { sendGtmPurchase } from "services/utils/sendGtm"

const NewSale = ({
  history,
  partnerSales,
  getPartnerCircuit,
  circuit,
  localityCnl,
  loading,
  loadingSale,
  error,
  messageError,
  duplicateNumber
}) => {
  const [formCurrent, setFormCurrent] = useState(INITIAL_STATE_FORM)
  const [order, setOrder] = useState({})
  const [type, setType] = useState("")

  const maxNumbers = 20

  const formik = useFormik({
    initialValues: INITIAL_VALUES,
    validate: (values) => validate(values, maxNumbers),
    onSubmit: (valuesForm) => {
      try {
        const codeLocality = find(localityCnl, [
          "locality",
          valuesForm.locality
        ])
        const isPortability = type === TYPE_OF_SALE.PORTABILITY.TITLE
        const action = isPortability
          ? TYPE_OF_SALE.PORTABILITY.ACTION
          : TYPE_OF_SALE.NEW_SALE.ACTION

        const valuesPhone = map(valuesForm.phonesPortability, (value) => {
          return "0".concat(removeMaskTel(value.phone))
        })

        const concatPhones = valuesPhone.join()

        const payload = {
          assigneeName: upperCase(valuesForm.assigneeName),
          assigneeDoc: removeMaskCPFCNPJ(valuesForm.assigneeDoc),
          circuit,
          codeLocality: codeLocality.cnl,
          action,
          value: isPortability ? concatPhones : null,
          qnt: valuesForm.qnt
        }

        partnerSales(payload, valuesForm, (resp) => {
          if (resp.code === "200") {
            history.push({
              pathname: "/fixed-voice/confirm-screen"
            })
          } else {
            showError(ERRORS_FIXED_VOICE.SALE_PORTABILITY)
          }
        })
      } catch (e) {
        showError(ERRORS_FIXED_VOICE.SALE_PORTABILITY)
      }
    }
  })

  const checkForm = () => {
    const typeOf = formik.values.typeOf
    const newSale = TYPE_OF_SALE.NEW_SALE.TITLE

    if (typeOf === newSale) {
      return formik.touched.qnt && formik.dirty
    }

    return formik.dirty
  }

  const ableSubmit = formik.isValid && formik.dirty && checkForm()

  const getPreviousElementName = (name) => {
    const keys = Object.keys(FIELDS_TO_VALIDATE)
    const currentIndex = keys.indexOf(name)
    if (currentIndex > 0) {
      return keys[currentIndex - 1]
    }
    return null
  }

  const verifyStepCardFields = (nameOrId) => {
    const { touched, values, errors } = formik

    if (
      nameOrId === INITIAL_STATE_FORM.amountOfNumbers.id &&
      type === "Portabilidade"
    ) {
      const alreadyTouched =
        touched.phonesPortability &&
        touched.phonesPortability.length === values.phonesPortability.length

      const existError = some(errors, (_, field) =>
        field.startsWith("phonesPortability")
      )

      return alreadyTouched && !existError
    }

    const alreadyTouched = FormUtils.verifyTouches(nameOrId, touched)
    const existError = FormUtils.verifyErrors(nameOrId, errors)

    return alreadyTouched && !existError
  }

  const updateElementToEditing = (nameOrId) => {
    setFormCurrent((prevForm) => {
      const updatedForm = { ...prevForm }
      for (const elementKey in updatedForm) {
        const element = updatedForm[elementKey]
        if (element.id === nameOrId || element.title === nameOrId) {
          updatedForm[elementKey] = {
            ...element,
            isEditing: true
          }
          break
        }
      }
      return updatedForm
    })
  }

  const updateElementToCompleted = (nameOrId) => {
    setFormCurrent((prevForm) => {
      const updatedForm = { ...prevForm }
      for (const elementKey in updatedForm) {
        const element = updatedForm[elementKey]
        if (element.id === nameOrId || element.title === nameOrId) {
          updatedForm[elementKey] = {
            ...element,
            isCompleted: true,
            isEditing: false
          }
          break
        }
      }
      return updatedForm
    })
  }

  const onChangeCard = (cardName) => {
    const previousCardName = getPreviousElementName(cardName)

    const isValidFields = previousCardName
      ? verifyStepCardFields(previousCardName)
      : verifyStepCardFields("typeOfSale")

    if (isValidFields) {
      updateElementToCompleted(previousCardName)
      updateElementToEditing(cardName)
    }
  }

  const onSubmitOrder = () => {
    formik.handleSubmit()
    sendGtmPurchase()
  }

  useEffect(() => {
    if (formCurrent.typeOfSale.isCompleted) {
      setType(formik.values.typeOf)
    }

    if (
      formCurrent.customerInfo.isCompleted ||
      formCurrent.amountOfNumbers.isCompleted
    ) {
      setOrder(formik.values)
    }
  }, [formCurrent])

  useEffect(() => {
    if (!circuit && !loading) {
      getPartnerCircuit()
    }
  }, [getPartnerCircuit])

  function handleError() {
    let messageUpdated

    switch (error) {
      case "LOCALITIES":
        showError(ERRORS_FIXED_VOICE.LOCALITIES)
        break

      case "SALE_PORTABILITY":
        showError({
          ...ERRORS_FIXED_VOICE.SALE_PORTABILITY,
          message: messageError
        })
        break

      case "INVALID_NUMBER":
        messageUpdated = _.replace(
          ERRORS_FIXED_VOICE.INVALID_NUMBER.message,
          "NUMBER",
          duplicateNumber
        )
        showError({
          ...ERRORS_FIXED_VOICE.INVALID_NUMBER,
          message: messageUpdated
        })
        break
    }
  }

  useEffect(() => {
    handleError()
  }, [error])

  const showError = (error) => {
    setFormCurrent(INITIAL_STATE_FORM)
    const message = `${error.title} <br><br>${error.message || ""}`
    return showToast({
      type: "error",
      acceptHtml: true,
      message
    })
  }

  return (
    <div className={`fullHeight ${styles.fixedVoice}`}>
      <BreadcrumbRouter />
      <div className={styles.containerSale}>
        <div className={styles.columnNewSale}>
          <h2>Cadastrar venda</h2>
          <form>
            <StepCard
              formCurrent={formCurrent.typeOfSale}
              onChangeSelect={onChangeCard}
              tab={1}
            >
              <SelectionFixedVoice formik={formik} />
            </StepCard>

            <StepCard
              formCurrent={formCurrent.customerInfo}
              onChangeSelect={onChangeCard}
              tab={3}
            >
              <CustomerInfo formik={formik} />
            </StepCard>

            <StepCard
              formCurrent={formCurrent.amountOfNumbers}
              onChangeSelect={onChangeCard}
              type={type}
              tab={8}
            >
              {type === TYPE_OF_SALE.PORTABILITY.TITLE ? (
                <PortedNumbers formik={formik} limit={maxNumbers} />
              ) : (
                <AmountNumbers formik={formik} limit={maxNumbers} />
              )}
            </StepCard>
          </form>
        </div>
        <div className={styles.columnsResume}>
          <OrderResume
            formValues={order}
            onSubmit={onSubmitOrder}
            ableSubmit={ableSubmit}
            typeOfSale={type}
            loading={loadingSale}
          />
        </div>
      </div>
    </div>
  )
}

NewSale.propTypes = {
  history: PropTypes.object,
  partnerSales: PropTypes.func,
  getPartnerCircuit: PropTypes.func,
  circuit: PropTypes.string,
  localityCnl: PropTypes.array,
  loading: PropTypes.bool,
  loadingSale: PropTypes.bool,
  error: PropTypes.string,
  duplicateNumber: PropTypes.array,
  messageError: PropTypes.string
}

const mapStateToProps = ({ newOrder }) => ({
  circuit: newOrder.circuit,
  loading: newOrder.loading,
  loadingSale: newOrder.loadingSale,
  localityCnl: newOrder.localities,
  error: newOrder.error,
  duplicateNumber: newOrder.duplicateNumber,
  messageError: newOrder.messageError
})

export default connect(mapStateToProps, { partnerSales, getPartnerCircuit })(
  NewSale
)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/index.js